import styled from 'styled-components';
import { Page } from 'components/molecules/page';
export const SettingsLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;
export const SettingsKryptonContainer = styled.div`
  flex: 1;
  min-height: 0;

  /* Target only the direct #page (Krypton's outer shell), not nested SettingsPage
     instances that own their own height and scroll. */
  > #page {
    height: 100%;
  }

  > #page > .ant-row {
    height: 100%;
  }

  > #page > .ant-row > .ant-col:first-child {
    height: 100%;
  }
`;
export const OktaWarningBanner = styled.div`
  background: var(--orange-10);
  border-bottom: 1px solid var(--orange-30);
  padding: 10px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--gray-90);
`;
export const OktaBannerText = styled.span`
  flex: 1;
`;
export const OktaBannerClose = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  color: var(--gray-70);
  flex-shrink: 0;
  &:hover {
    color: var(--gray-90);
    background: var(--orange-20);
  }
`;
export const SettingsPageContent = styled(Page.Content)`
  padding: 0 var(--layout-01) var(--layout-01) var(--layout-01);
  overflow-y: auto;
  height: 100vh;
  border-radius: 0;
  > .ant-row {
    padding: var(--spacing-03);
  }
`;
export const SettingsPage = styled(Page).attrs({
    $gray: false,
    $overflow: true
})`
  padding-top: 0;
  padding-bottom: 0;
  height: calc(100vh - 16px);
  border-radius: 0;
  ${Page.Header} {
    border-radius: 0 8px 0 0;
  }
`;
